// IMAGES

// import Icon from '../../assets/roulette-selector.png';
import Icon from "./roulette-selector.png";

const rouletteSelector = new Image();
rouletteSelector.src = Icon;

export { rouletteSelector };
